// extracted by css-extract-rspack-plugin
export default {"subtitle":"subtitle-z6DKQW text-body-sm","asterisk":"asterisk-GIcdll"};